import dayjs from "dayjs-ext";
function csvDownload(that,apex) {
    //let self = this;
    // console.log(that.$refs[`${apex}`].options.xaxis)
    let column1 = that.$refs[`${apex}`].options.xaxis.categories;
    if(that.$refs[`${apex}`].options.xaxis.title){
        column1.unshift(`${that.$refs[`${apex}`].options.xaxis.title.text}`);
    }

    let column2 = that.$refs[`${apex}`].series[0].data;
    if(that.$refs[`${apex}`].options.yaxis[0].title){
        column2.unshift(`${that.$refs[`${apex}`].options.yaxis[0].title.text}`);
    }
    const rows = [];
    for (var i = 0; i < column1.length; i++) {
        rows.push([column1[i], column2[i]]);
    }

    let csvContent = "data:text/csv;charset=utf-8,";

    rows.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });
    triggerDownload(
        encodeURI(csvContent),
        `${dayjs().format("DD/MM/YYYY HH:mm:ss")}`,
        ".csv"
    );
}
function pngDownload() {
    //let self = this;
    dataURI().then(({ imgURI, blob }) => {
        if (blob) {
            navigator.msSaveOrOpenBlob(
                blob,
                window.Apex._chartInstances[0].chart.w.globals.chartID + ".png"
            );
        } else {
            triggerDownload(
                imgURI,
                `${dayjs().format("DD/MM/YYYY HH:mm:ss")}`,
                ".png"
            );
        }
    });
}
function svgDownload() {
    //let self = this;
    triggerDownload(
        svgUrl(),
        `${dayjs().format("DD/MM/YYYY HH:mm:ss")}`,
        ".svg"
    );
}
function dataURI() {
    //let self = this;
    return new Promise((resolve) => {
        const w = window.Apex._chartInstances[0].chart.w;

        cleanup();
        const canvas = document.createElement("canvas");
        canvas.width = w.globals.svgWidth;
        canvas.height = parseInt(w.globals.dom.elWrap.style.height, 10); // because of resizeNonAxisCharts

        const canvasBg =
            w.config.chart.background === "transparent"
                ? "#fff"
                : w.config.chart.background;

        let ctx = canvas.getContext("2d");
        ctx.fillStyle = canvasBg;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const svgData = getSvgString();

        if (window.canvg && isIE11()) {
            // use canvg as a polyfill to workaround ie11 considering a canvas with loaded svg 'unsafe'
            // without ignoreClear we lose our background color; without ignoreDimensions some grid lines become invisible
            let v = window.canvg.Canvg.fromString(ctx, svgData, {
                ignoreClear: true,
                ignoreDimensions: true,
            });
            // render the svg to canvas
            v.start();

            let blob = canvas.msToBlob();
            // dispose - missing this will cause a memory leak
            v.stop();

            resolve({ blob });
        } else {
            const svgUrl = "data:image/svg+xml," + encodeURIComponent(svgData);
            let img = new Image();
            img.crossOrigin = "anonymous";

            img.onload = () => {
                ctx.drawImage(img, 0, 0);

                if (canvas.msToBlob) {
                    // IE and Edge can't navigate to data urls, so we return the blob instead
                    let blob = canvas.msToBlob();
                    resolve({ blob });
                } else {
                    let imgURI = canvas.toDataURL("image/png");
                    resolve({ imgURI });
                }
            };

            img.src = svgUrl;
        }
    });
}
function isIE11() {
    if (
        window.navigator.userAgent.indexOf("MSIE") !== -1 ||
        window.navigator.appVersion.indexOf("Trident/") > -1
    ) {
        return true;
    }
}
function svgUrl() {
    //let self = this;
    cleanup();

    const svgData = getSvgString();
    const svgBlob = new Blob([svgData], {
        type: "image/svg+xml;charset=utf-8",
    });
    return URL.createObjectURL(svgBlob);
}
function getSvgString() {
    //let self = this;
    const svgString = window.Apex._chartInstances[0].chart.w.globals.dom.Paper.svg();

    return fixSvgStringForIe11(svgString);
}
function fixSvgStringForIe11(svgData) {
    //let self = this;
    // IE11 generates broken SVG that we have to fix by using regex
    if (!isIE11()) {
        // not IE11 - noop
        return svgData;
    }

    // replace second occurence of "xmlns" attribute with "xmlns:xlink" with correct url + add xmlns:svgjs
    let nXmlnsSeen = 0;
    let result = svgData.replace(
        /xmlns="http:\/\/www.w3.org\/2000\/svg"/g,
        (match) => {
            nXmlnsSeen++;
            return nXmlnsSeen === 2
                ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"'
                : match;
        }
    );

    // remove the invalid empty namespace declarations
    result = result.replace(/xmlns:NS\d+=""/g, "");
    // remove these broken namespaces from attributes
    result = result.replace(/NS\d+:(\w+:\w+=")/g, "$1");

    return result;
}
function cleanup() {
    //let self = this;

    // hide some elements to avoid printing them on exported svg
    const xcrosshairs = window.Apex._chartInstances[0].chart.w.globals.dom.baseEl.getElementsByClassName(
        "apexcharts-xcrosshairs"
    );
    const ycrosshairs = window.Apex._chartInstances[0].chart.w.globals.dom.baseEl.getElementsByClassName(
        "apexcharts-ycrosshairs"
    );
    const zoomSelectionRects = window.Apex._chartInstances[0].chart.w.globals.dom.baseEl.querySelectorAll(
        ".apexcharts-zoom-rect, .apexcharts-selection-rect"
    );
    Array.prototype.forEach.call(zoomSelectionRects, (z) => {
        z.setAttribute("width", 0);
    });
    if (xcrosshairs && xcrosshairs[0]) {
        xcrosshairs[0].setAttribute("x", -500);
        xcrosshairs[0].setAttribute("x1", -500);
        xcrosshairs[0].setAttribute("x2", -500);
    }
    if (ycrosshairs && ycrosshairs[0]) {
        ycrosshairs[0].setAttribute("y", -100);
        ycrosshairs[0].setAttribute("y1", -100);
        ycrosshairs[0].setAttribute("y2", -100);
    }
}
function triggerDownload(href, filename, ext) {
    //let self = this;
    const downloadLink = document.createElement("a");
    downloadLink.href = href;
    downloadLink.download = filename + ext;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

export {
    csvDownload,
    pngDownload,
    svgDownload,
    dataURI,
    isIE11,
    svgUrl,
    getSvgString,
    fixSvgStringForIe11,
    cleanup,
    triggerDownload
}